import * as types from './types';

export function clearCarrierGuideContent(data) {
    return {
        payload: data,
        type: types.CLEAR_CARRIER_GUIDE_CONTENT,
    };
}

export function setCarrierGuideContent(data, carrierGuideId) {
    return {
        meta: carrierGuideId,
        payload: data,
        type: types.SET_CARRIER_GUIDE_CONTENT,
    };
}
